import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import MainContentInnerHtml from 'components/MainContentInnerHtml';
import MaxWidthPageImage from 'components/MaxWidthPageImage';
import Page from 'components/Page';
import { getRoute } from '@common/constants/CampusRoutes';
import store from 'store';

import StrengthsImageSrc from '@common/assets/images/about-me/personal-qualities/personal-qualities_lg.jpg';
import useModel from '@common/helpers/useModel';
import StudentProfileModel, {
	IStudentProfileModel,
} from '@common/models/StudentProfile/StudentProfile';

function QualitiesPage() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const studentProfile: IStudentProfileModel = useModel(
		StudentProfileModel,
		{ id: store.currentStudentId },
		[store.currentStudentId],
		{
			disableFetch: true,
		},
	);

	const handleGoBack = () => {
		navigate(getRoute(['REPORT', 'ABOUT']));
	};

	useEffect(() => {
		studentProfile.fetchStudent(!!store?.profile?.parent);
	}, []);

	return (
		<Page
			type="content"
			title={t('report.aboutMe.personalityQualities')}
			onGoBack={handleGoBack}
			isLoading={studentProfile.loading}
		>
			<MainContentInnerHtml text={studentProfile.personalQuality?.title} />
			<MaxWidthPageImage alt="Main personality qualities image" src={StrengthsImageSrc} />
			<MainContentInnerHtml text={studentProfile.personalQuality?.description} />
		</Page>
	);
}

export default observer(QualitiesPage);
